import React, {useEffect} from "react";
import axios from "axios";

import {VIEW_TRACKING_ENDPOINT} from "@/constants/endpoints.jsx";

export default function ViewTracking() {
    useEffect(() => {
        trackPageView();
    }, []);

    const trackPageView = async () => {
        try {
            await axios.post(VIEW_TRACKING_ENDPOINT, {
                path: location.pathname + location.search,
            }, {
                withCredentials: true,
                validateStatus: function (status) {
                    return status < 500;
                },
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'multipart/form-data',
                },
            });
        } catch (error) {
            console.error('tracking error', error);
        }
    };

    return null;
};
